// refLabelNavigation.js

import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-textmate";

/**
 * Convert string index to Ace editor row/col
 */
export function getPositionFromIndex(text, startIndex, length) {
    let row = 0;
    let col = 0;

    for (let i = 0; i < startIndex; i++) {
        if (text[i] === "\n") {
            row++;
            col = 0;
        } else {
            col++;
        }
    }

    const startRow = row;
    const startCol = col;

    for (let i = startIndex; i < startIndex + length; i++) {
        if (text[i] === "\n") {
            row++;
            col = 0;
        } else {
            col++;
        }
    }

    return { startRow, startCol, endRow: row, endCol: col };
}

/**
 * Set up Ref/Label navigation in Ace Editor
 */
export function JumpFunctionality(ace, toast) {
    if (!ace?.current?.editor) return;

    const editor = ace.current.editor;
    const session = editor.session;

    // Find a label by name
    const findLabelPosition = (text, labelName) => {
        const regex = /\\label\{/g;
        let match;

        while ((match = regex.exec(text)) !== null) {
            let startIndex = match.index + match[0].length;
            let braceCount = 1;
            let endIndex = startIndex;

            while (endIndex < text.length && braceCount > 0) {
                if (text[endIndex] === "\\") {
                    endIndex += 2;
                    continue;
                }
                if (text[endIndex] === "{") braceCount++;
                else if (text[endIndex] === "}") braceCount--;
                endIndex++;
            }

            if (braceCount === 0) {
                const foundLabel = text.slice(startIndex, endIndex - 1).trim();
                if (foundLabel === labelName) {
                    return getPositionFromIndex(text, match.index, 0);
                }
            }
        }
        return null;
    };

    // Find ref at cursor position
    const findRefAtPosition = (text, row, column) => {
        const line = session.getLine(row);

        const refPattern = /\\(ref|eqref|cite|pageref|autoref|nameref)\{([^}]*)\}/g;
        let match;

        while ((match = refPattern.exec(line)) !== null) {
            const matchStart = match.index;
            const matchEnd = match.index + match[0].length;

            if (column >= matchStart && column <= matchEnd) {
                const command = match[1];
                const labelName = match[2].trim();

                return { command, labelName, isRef: true };
            }
        }

        // Check for \label under cursor
        const labelPattern = /\\label\{([^}]*)\}/g;
        while ((match = labelPattern.exec(line)) !== null) {
            if (column >= match.index && column <= match.index + match[0].length) {
                return { command: "label", labelName: match[1].trim(), isRef: false };
            }
        }

        return null;
    };

    // Find all refs that use a label
    const findRefsForLabel = (text, labelName) => {
        const refs = [];
        const commands = ["ref", "eqref", "cite", "pageref", "autoref", "nameref"];

        commands.forEach((command) => {
            const regex = new RegExp(`\\\\${command}\\{`, "g");
            let match;

            while ((match = regex.exec(text)) !== null) {
                let startIndex = match.index + match[0].length;
                let braceCount = 1;
                let endIndex = startIndex;

                while (endIndex < text.length && braceCount > 0) {
                    if (text[endIndex] === "\\") {
                        endIndex += 2;
                        continue;
                    }
                    if (text[endIndex] === "{") braceCount++;
                    else if (text[endIndex] === "}") braceCount--;
                    endIndex++;
                }

                if (braceCount === 0) {
                    const refLabel = text.slice(startIndex, endIndex - 1).trim();
                    const labels = refLabel.split(",").map((l) => l.trim());

                    if (labels.includes(labelName)) {
                        const position = getPositionFromIndex(text, match.index, 0);
                        refs.push({ command, row: position.startRow, column: position.startCol });
                    }
                }
            }
        });

        return refs;
    };

    // Click handler
    const handleClick = (e) => {
        if (!e.domEvent.ctrlKey && !e.domEvent.metaKey) return;

        const position = e.getDocumentPosition();
        const text = session.getValue();

        const clickInfo = findRefAtPosition(text, position.row, position.column);
        if (!clickInfo) return;

        if (clickInfo.isRef) {
            const labelPos = findLabelPosition(text, clickInfo.labelName);
            if (labelPos) {
                editor.gotoLine(labelPos.startRow + 1, labelPos.startCol, true);
                editor.scrollToLine(labelPos.startRow, true, true);
            } else {
                // alert(`Label "${clickInfo.labelName}" not found`);
                // toast({
                //     title: `missing label`,
                //     description: `No references found for label "${clickInfo.labelName}"`,
                //     status: "warning",
                //     duration: 4000,
                //     isClosable: true
                // });

            }
        } else {
            const refs = findRefsForLabel(text, clickInfo.labelName);
            if (refs.length > 0) {
                const firstRef = refs[0];
                editor.gotoLine(firstRef.row + 1, firstRef.column, true);
                editor.scrollToLine(firstRef.row, true, true);
            } else {
                // toast({
                //     title: `missing label`,
                //     description: `No references found for label "${clickInfo.labelName}"`,
                //     status: "warning",
                //     duration: 4000,
                //     isClosable: true
                // });
            }
        }
    };

    // Mouse move to show pointer cursor
    const handleMouseMove = (e) => {
        const position = editor.renderer.screenToTextCoordinates(e.clientX, e.clientY);
        const text = session.getValue();
        const clickInfo = findRefAtPosition(text, position.row, position.column);

        if ((e.ctrlKey || e.metaKey) && clickInfo) {
            editor.container.style.cursor = "pointer";
        } else {
            editor.container.style.cursor = "text";
        }
    };

    // Add listeners
    editor.on("click", handleClick);
    editor.container.addEventListener("mousemove", handleMouseMove);

    // Return cleanup function
    return () => {
        editor.off("click", handleClick);
        editor.container.removeEventListener("mousemove", handleMouseMove);
    };
}
